interface Props {
  label: string;
  value: string;
}

export default function ProjectUsabilityMobileAppDebugStat({
  label,
  value,
}: Props) {
  return (
    <div className='flex flex-col rounded bg-white/5 px-1.5 py-0.5'>
      <span className='text-[8px] tracking-wide text-white/50 uppercase'>
        {label}
      </span>
      <span className='font-mono text-[10px]'>{value}</span>
    </div>
  );
}
